import request from '@/utils/request'

/** 获取菜单列表 */
export function fetchNavList() {
    return request({
        url: '/channels',
        method: 'get',
    })
}